import { create } from "zustand";
export const useResultStore = create((set) => ({
   isLoading: false,
   allOrganizations: [],
   selectedAssessments: [],
   selectedSubmissionRounds: [],

   allSurveys: [],
   activeSurvey: [],
   activeSectionSurvey: [],

   surveysDropdown: [],
   //AllData
   submissionRounds: [],
   setSubmissionRounds: (payload) => {
      set({submissionRounds: payload})
   },
   assessmentRanges: [],
   setAssessmentRanges: (payload) => {
      set({assessmentRanges: payload})
   },
   setSurveysDropdown: (payload) => {
      set({surveysDropdown: payload})
   },

   setAllOrganizations: (payload) => {
      set({ isLoading: true });
      set({ allOrganizations: payload });
   },

   setActiveAssessment: (payload) => {
      set({ selectedAssessments: payload });
   },

   setAllSurveys: (payload) => {
      set({ allSurveys: payload });
   },
   setActiveSurvey: (payload) => {
      set({ activeSurvey: payload });
   },

   setActiveSurveySection: (payload) => {
      set({ activeSectionSurvey: payload });
   },

   setSelectedSubmissionRounds: (payload) => {
      set({ selectedSubmissionRounds: payload });
   },


   // Active Tab
   activeTab: {},
   setActiveTab: (payload) => {
      set({activeTab: payload});
   },


   // 
   scorePerSurvey: [],
   setScorePerSurvey: (payload) => {
      set({scorePerSurvey: payload})
   },
   scorePerSection: [],
   setScorePerSection: (payload) => {
      set({scorePerSection: payload})
   },
   overAllScores: [],
   setOverAllScores: (payload) => {
      set({overAllScores: payload})
   },

   //loader
   rangesLoader: false,
   setRangesLoader: (payload) => {
      set({rangesLoader: payload})
   },
   roundsLoader: false,
   setRoundsLoader: (payload) => {
      set({roundsLoader: payload})
   },
   assessmentLoader: false,
   setAssessmentLoader: (payload) => {
      set({assessmentLoader: payload})
   },
   graphsLoader: false,
   setGraphsLoader: (payload) => {
      set({graphsLoader: payload})
   },
   tableViewLoader: false,
   setTableViewLoader: (payload) => {
      set({tableViewLoader: payload})
   },

   // Table
   tableActiveSurvey: null,
   setTableActiveSurvey: (payload) => {
      set({tableActiveSurvey: payload})
   },
   tableViewData: null,
   setTableViewData: (payload) => {
      set({tableViewData: payload})
   },


   // Tabs
   activeTab: '1',
   setActiveTab: (payload) => {
      set({activeTab: payload})
   } 
}));
